import { useTranslation } from 'react-i18next'
import Button from '@/shared/components/Button/Button'
import { useFloorPlanSave } from '../../hooks/useFloorPlanSave'

/**
 * Self-contained control that persists the whole floor plan to the backend on
 * click. Drop it anywhere, it wires its own state through useFloorPlanSave,
 * no props required.
 *
 * The label and styling never change: the outcome of a save is reported through
 * the snackbar, not by mutating the button. Only the brief in-flight moment
 * disables it, so a double click can't fire two saves.
 */
function SavePlanButton() {
  const { t } = useTranslation()
  const { save, status, canSave } = useFloorPlanSave()

  // Nothing to persist to when the API is disabled.
  if (!canSave) return null

  return (
    <Button
      label={t('FLOOR_PLAN.TOOLBAR.SAVE')}
      variant="contained"
      color="primary"
      icon="las la-save"
      disabled={status === 'saving'}
      onClick={save}
    />
  )
}

export default SavePlanButton
